module.exports = __webpack_public_path__ + "img/r-3.24f7ae6c.jpg";